/**
 * Tooltip component - HTML5 Custom Element
 * Desktop: hover to show/hide
 * Mobile: tap to toggle, tap outside to close
 */
export class IaTooltip extends HTMLElement {
  constructor() {
    super();
    this.isTouch = false;
    this.boundOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.tooltip = this.querySelector('.ia-tooltip');
    this.trigger = this.querySelector('.ia-tooltip-trigger');
    this.closeBtn = this.querySelector('.ia-tooltip__close');

    if (!this.tooltip || !this.trigger) return;

    // Detect touch on first interaction
    this.addEventListener('touchstart', () => { this.isTouch = true; }, { once: true });

    // Desktop: hover
    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));

    // Mobile: tap trigger to toggle
    this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.handleCloseClick.bind(this));
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.boundOutsideClick);
  }

  handleMouseEnter() {
    if (!this.isTouch) this.show();
  }

  handleMouseLeave() {
    if (!this.isTouch) this.hide();
  }

  handleTriggerClick(e) {
    if (this.isTouch) {
      e.preventDefault();
      this.isOpen() ? this.hide() : this.show();
    }
  }

  handleCloseClick(e) {
    e.stopPropagation();
    this.hide();
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.hide();
    }
  }

  isOpen() {
    return this.hasAttribute('data-open');
  }

  show() {
    this.setAttribute('data-open', '');
    this.tooltip.setAttribute('aria-hidden', 'false');
    // Listen for outside clicks (mobile)
    if (this.isTouch) {
      setTimeout(() => document.addEventListener('click', this.boundOutsideClick), 0);
    }
  }

  hide() {
    this.removeAttribute('data-open');
    this.tooltip.setAttribute('aria-hidden', 'true');
    document.removeEventListener('click', this.boundOutsideClick);
  }
}

if (!customElements.get('ia-tooltip')) {
  customElements.define('ia-tooltip', IaTooltip);
}
